function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#5768a8;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Icon-logout");

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  id: "spacer",
  className: "cls-1",
  width: 32,
  height: 32
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "logout",
  className: "cls-2 fill",
  d: "M8.37,22.36,9.79,21,5.84,17H18V15H5.84l3.95-3.95L8.37,9.64,2,16ZM29.93,4V28a2,2,0,0,1-2,2h-16a2,2,0,0,1-2-2V24h2v4h16V4h-16V8h-2V4a2,2,0,0,1,2-2h16A2,2,0,0,1,29,2.34a2.17,2.17,0,0,1,.55.54A2.05,2.05,0,0,1,29.93,4Z"
});

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.dfeec979.svg";
export { ForwardRef as ReactComponent };